import type { InputBaseComponentProps } from '@mui/material';
import InputAdornment, { InputAdornmentProps } from '@mui/material/InputAdornment';
import React from 'react';

import { NumericFormat } from 'react-number-format';

export function MuiInputAdornment(props: InputAdornmentProps) {
	return <InputAdornment {...props} />;
}

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
	defaultValue?: string;
	positiveOnly?: boolean;
}

export const NumberFormatCustom = React.forwardRef<HTMLInputElement, InputBaseComponentProps & CustomProps>(function NumberFormatCustom(props, ref) {
	const { onChange, positiveOnly, ...other } = props;

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={values => {
				onChange?.({
					target: {
						name: props.name,
						value: values.value
					}
				});
			}}
			thousandSeparator
			decimalScale={2}
			valueIsNumericString
			isAllowed={values => {
				if (positiveOnly) {
					const { floatValue } = values;

					// Prevent -0 and any negative numbers
					if (floatValue !== undefined && (floatValue < 0 || Object.is(floatValue, -0))) {
						return false;
					}

					return values.value === '' || (floatValue !== undefined && floatValue >= 0);
				}
				return true;
			}}
		/>
	);
});
